import type { Transition } from "@uirouter/core";

import { KEYWORD_GROUP_PREFIX } from "app/services/keyword-groups";
import type { transitionHookFn } from "app/routes/handlers/redirectFunctions/redirectPipe";

export const onRedirectAliasMonitorKeywordsParam: transitionHookFn = (transition: Transition) => {
    const toParams = transition.params("to") as { keyword?: string; keywordGroupId?: string };

    // If keyword is missing but keywordGroupId exists, alias keywordGroupId to keyword
    // This ensures consistency across all keyword-related states
    if (!toParams?.keyword && toParams?.keywordGroupId) {
        return { params: { ...toParams, keyword: `${KEYWORD_GROUP_PREFIX}${toParams.keywordGroupId}` } };
    }
};
